module.exports = __webpack_public_path__ + "4e4542926198b68395da82cdfcff04c8.svg";